$(".article__body img").each(function() {
  const $this = $(this);
  const imgAlt = $this.attr("alt");
  if (imgAlt.length > 0) {
    $this.wrap('<div class="image-wrapper"></div>');
    $this.after(`<div class="article__caption">${imgAlt}</div>`);
  }
});



// WEBPACK FOOTER //
// ../assets/js/article-imges.js